import ReactDOM from 'react-dom/client'
import { ChakraUiProvider } from './ChakraUiProvider';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { DashboardPage } from './dashboard/DashboardPage';
import { CoursePage } from './course/CoursePage';
import { SurveyPage } from './course/SurveyPage';
import { AdminPage } from './admin/AdminPage';
import { EditSurveyTemplatePage } from './admin/EditSurveyTemplatePage';
import { TelemetryClientService } from './services/TelemetryClientService.ts';

import '@/assets/global.scss'
import { EditlTemplatePage } from './admin/EditlTemplatePage.tsx';
import { PageLayout } from './comments/PageLayout.tsx';
import { MarkdownPage } from './dashboard/MarkdownPage.tsx';
import { Hero } from './dashboard/Hero.tsx';

const router = createBrowserRouter([
  {
    path: "",
    element: <PageLayout footer={true} />,
    children: [
      {
        path: "",
        element: <Hero />,
      },
      {
        path: "admin/:tab?",
        element: <AdminPage />,
      },
      {
        path: "admin/:templateKind/:templateId",
        element: <EditlTemplatePage />,
      },
      {
        path: "course/:courseId",
        element: <CoursePage />,
      }
    ],
  },
  {
    path: "",
    element: <PageLayout footer={false} />,
    children: [
      {
        path: "page/:fileName",
        element: <MarkdownPage />,
      },
      {
        path: ":tab",
        element: <DashboardPage />,
      },
      {
        path: "course/:courseId/:moduleId/:action/:pageId?",
        element: <SurveyPage />
      },
      {
        path: "admin/template/:fileName",
        element: <EditSurveyTemplatePage />,
      },
    ]
  }
]);

TelemetryClientService.initialize();
TelemetryClientService.page('App');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ChakraUiProvider>
    <RouterProvider router={router} />
  </ChakraUiProvider>
)
